module.exports = __webpack_public_path__ + "media/native-apps/vasterbotten-1ed5ffab.webp";